export default function PageSkeleton() {
    return (
        <div className="flex min-h-[50vh] items-center justify-center bg-canvas">
            <div className="h-8 w-8 animate-pulse rounded-full border-2 border-[#fca311] border-t-transparent" />
        </div>
    );
}
